import { defaultAmount } from "../../constants"
import produce from "immer"

const initialState = {
    loggedIn: false,
    registered: false,
    currentRide: null,
    userFirstName: null,
    userLastName: null,
    activeSubscriptionName: null,
    walletBalance: 0,
    canStartRide: false,
    ridesSummary: undefined,
    userProfile: undefined,
    userProfileError: undefined,
    rideStartMinimumCredit: defaultAmount,
}

export const reducer = produce((draft, action) => {
    switch (action.type) {
        case "FETCH_ME_SUCCESS":
            draft.loggedIn = true
            draft.registered = action.response.registered
            draft.currentRide = action.response.lastRide;
            draft.userFirstName = action.response.firstName;
            draft.userLastName = action.response.lastName;
            draft.activeSubscriptionName = action.response.activeSubscriptionName;
            draft.walletBalance = action.response.walletBalance;
            draft.canStartRide = action.response.canStartRide;
            draft.rideStartMinimumCredit = action.response.rideStartMinimumCredit;
            draft.ridesSummary = action.response.userRidesSummary;
            break;
        case 'FETCH_USER_PROFILE_REQUEST':
            draft.userProfile = undefined;
            break;
        case 'FETCH_USER_PROFILE_SUCCESS':
            draft.userProfile = action.response;
            break;
        case 'FETCH_USER_PROFILE_FAILURE':
            draft.userProfileError = action.error;
            break;
        default:
            draft.error = action.error
            break
    }
}, initialState)

function deRoot(state) {
    return state.user
}

export function selectUserRegistered(state) {
    return deRoot(state).registered
}

export function selectUserLoggedIn(state) {
    return deRoot(state).loggedIn
}

export function selectUserCurrentRide(state) {
    return deRoot(state).currentRide
}

export function selectUserFirstName(state) {
    return deRoot(state).userFirstName;
}

export function selectUserLastName(state) {
    return deRoot(state).userLastName;
}

export function selectWalletBalance(state) {
    return deRoot(state).walletBalance;
}

export function selectCanStartRide(state) {
    return deRoot(state).canStartRide;
}

export function selectRideStartMinimumCredit(state) {
    return deRoot(state).rideStartMinimumCredit;
}

export function selectActiveSubscriptionName(state) {
    return deRoot(state).activeSubscriptionName;
}

export function selectRidesSummary(state){
    return deRoot(state).ridesSummary;
}

export function selectUserProfile(state) {
    return deRoot(state).userProfile;
}
